import { useCallback, useEffect } from 'react';
type ShortcutErrorT = {
  errorKey: string;
  message: string;
};
type RegisterHotKeysT = (hotkeys: Array<{
  keys: string[];
  onAction: (event: KeyboardEvent) => void;
}>) => {
  removeHotKeys: () => void;
  errors?: ShortcutErrorT[];
};
type PropsT = {
  registerHotKeys: RegisterHotKeysT;
  selectedAnnotationIds: string[];
  annotationList: any[];
  toggleShowHideAnnotations: (hidden: boolean, annotationId: string) => void;
};
const useHideShortcutKeyHandlers = ({
  registerHotKeys,
  selectedAnnotationIds,
  annotationList,
  toggleShowHideAnnotations
}: PropsT) => {
  const handleToggleVisibility = useCallback((event: KeyboardEvent) => {
    event.stopPropagation();
    if (!selectedAnnotationIds.length) return;
    selectedAnnotationIds.forEach(id => {
      const annotation = annotationList.find(ann => ann.id === id);
      if (!annotation) return;
      toggleShowHideAnnotations(!annotation.hidden, id);
    });
  }, [selectedAnnotationIds, annotationList, toggleShowHideAnnotations]);
  useEffect(() => {
    const {
      removeHotKeys,
      errors
    } = registerHotKeys([{
      keys: ['h'],
      onAction: handleToggleVisibility
    }]);
    errors?.forEach(error => {
      console.warn(`Shortcut registration error: ${error.errorKey} - ${error.message}`);
    });
    return () => {
      removeHotKeys();
    };
  }, [registerHotKeys, handleToggleVisibility]);
};
export default useHideShortcutKeyHandlers;